var exports = {
  "R": "x4c3adb35--99bc22--preloader",
  "i": "x4c3adb35--99bc22--preloader-mobile",
};

module.exports = exports;
